// 定义英文语言包对象
export default {
    navigateBar: {
        hotspot: 'Hotspot',
        experience: 'Experience',
        focus: 'Focus',
        recommend: 'Recommend',
        Home: 'Home',
        records: 'Records',
        New: 'New',
        Hot: "Hot",
        Rank: "Top Games",
        calegories: 'Categories',
        about: 'About',
        about_us: 'About us',
        contact_us: 'Contact us',
        feedback: 'Feedback',
        fqa: 'FAQs',
        user_privacy: "Privacy Policy",
        sbervice_Terms: "Terms of Service",
        business_cooperation: 'Business cooperation',
        developers: "developers",
        new_games: 'New games',
        hot_games: 'Hot games',
        rank_games: 'Rank',
        view_more: 'view more',
        friends: "Friends",
        favorites: "Favorites",
        user_center: "User Center",


        FriendsTotal: "FriendsTotal",
        FavoritesTotal: "FavoritesTotal",
        GamePlayedTotal: "GamePlayedTotal",
        GameLikedTotal: "GameLikedTotal",


        mob_FriendsTotal: "Friends",
        mob_FavoritesTotal: "Favorites",
        mob_GamePlayedTotal: "GamePlayed",
        mob_GameLikedTotal: "GameLiked",
        Recently_Played: 'Recently Played',
        Favorites: "Favorites",
        My_wallet: "My wallet",
        LogOut: "LogOut",
        Del_Accout: "Del Accout",
        Confirm: "Confirm",
        Cancel: "Cancel",
        twdya: "This will deactivate your account",
        newuser: "New to iGlees，",
        Register: "Register",
        Forget_Password: "Forget Password",
        Login: 'Login',
        // Third Party authorfzation Login
        tpal: "Third Party authorfzation Login",
        Hasaccount: "Has account , ",
        iam13: "I am over 13 years old (or the applicable minimum age) and understand and accept the  <a class='atext' href='/terms_of_service.html' target='_blank' rel='noopener noreferrer'>Terms of Service</a> and <a class='atext' href='/privacy_policy.html' target='_blank' rel='noopener noreferrer'>Privacy Policy</a>",

        Reset_Password: "Reset Password",
        Bring_your_friends: "Bring your friends！",
        Create_a_CrazyGames: "Create an account",
        start_inviting_your_friends: "start inviting your friends",
        Invitte_your_friends: "Invite your friends",
        FindFriendsbySearchiingForTheirUsemames: "Find Friends by Searchiing For Their Usemames,",
        or: "or",
        ShareyourQrcodeinviteLink: "or Share your Qrcode/invite Link",
    },
    List: "List",
    Received: "Received",
    Sent: 'Sent',
    Mine: "Mine",
    // Show this QR code to your friends so they can scan it with
    showqr: 'Show this QR code to your friends so they can scan it with',
    // 并向您发送好友请求
    sendyoufdre: "their camera and send you a friend request",
    Shareyourprofile: "Share your profile",
    CopyInviteLink: "Copy Invite Link",
    Massage: "Massage",
    Your_emall: "Your emall（optional）",
    FeebackType: "Feeback Type",
    Phoneoptional: "Phone （optional）",
    Submit: "Submit",
    feebackgame: "Feeback Game",
    Playnow: "Play now",
    GameDescription: "Game Description",
    Rating: "Rating",
    Developer: "Developer",
    Released: "Released",
    LastUpdated: "Last Updated",
    Technology: "Technology",
    Platforms: 'Platforms',
    Classification: "Classification",
    Tags: 'Tags',
    Dontrecommend: 'Don`t recommend',
    Sharegame: 'Share game',
    Ratinggame: "Rating game",
    All: "All",
    Annoucement: "Annoucement",
    Private: 'Private',
    Activity: 'Activity',
    Unread: 'Unread',
    Read: "Read",
    BatchSetRead: 'Batch Set Read',
    Manage: "Manage",
    Delete: "Delete",
    passwordage: 'Min. 8 chars with: upper, lower, number, symbol.',
    plpassword: "Please input the password",
    plemail: 'Please input the email',
    emailformat: 'Please enter a valid email format',
    emailsending: 'Sending verification code, please wait...',
    emailsuccess: 'Verification code sent successfully, please check your email',
    emailfailed: 'Failed to send verification code, please try again',
    emailwait: 'Please wait {time} seconds before sending again',
    networkerror: 'Network error, please try again later',
    plemailcode: "Please enter  email verify code",
    plSelectfd: "Please Select feedback type",
    UserAgreement: "Please agree to the User Agreement",
    plfbmes: 'Please enter feedback message',
    plphone: "Please enter your phone",
    phoneformat: 'Please enter a valid phone format',
    //Please enter your email address
    pladdemail: "Please enter your email address",
    //Please select a favorite game
    plselefg: "Please select a favorite game",
    // Received Request
    ReceivedRequest: "Received Request",
    // Sent Request
    SentRequest: "Sent Request",
    Searchgame: "Search game",
    Searchbygame: "Search Game by name",
    plgnsg: "Please Input game name search game",
    PlIyophone: 'Please Input your phone No',
    //Find  Frieds By Searching for their usemames
    FindFrieds: "Find  Frieds By Searching for their usemames",
    Searchms: "Search name",
    useinfochage: "Modify information",
    usecomplete: "Complete",
    Notyet: "Not yet",
    pllogin: 'Please log in first',
    Controls: "Controls",
    Sharethegame: 'Share the game',
    Send: "Send",
    // Login successful
    Loginsuccessful: "Login successful",
    // /Login failed
    Loginfailed: "Loginfailed",
    Alltoal: "All",
    // Please enter your email address
    peuea: "Please enter your email address",
    statrtime: "Start date",
    endtime: "End date",
    timetogo: "to",
    Screenshotproblem: "Screenshot of the problem",
    Quickmaps: "Quick maps",
    Screenshot: "Upload a picture or screenshot of the problem",
    Gamedetail: "Game Details",
    copygamelink: "copy",
    tabs: {
        work: 'Work',
        private: 'Private',
        collect: 'Collect',
        like: 'Like'
    },
    Undercpst: 'Under construction, please stay tuned!',
    Continueplaying: "Continue playing",
    NoUsersFound: "No users found",
    Sharefriends: 'Share friends',
    cookieBanner: {
        title: "Cookie Notice",
        description: "We use cookies and similar technologies to improve our website's operation, provide personalized experiences, and deliver advertising based on your browsing activities and interests. By continuing to use our site, you agree to our use of cookies.",
        learnMore: "Learn More",
        accept: "Accept All",
        reject: "Reject Non-Essential",
    }
}